import { useComponent } from "@/hooks/useMicrositeComponent";

import { IMicrositeComponent, MComponentDivider } from "@/types/microsite";
import { cn } from "@/lib/utils";
import { useMemo } from "react";

const DividerComponent = {
  kind: "DIVIDER",
  Render: ({
    isBuilder,
    id,
    data: { dividerHeight, dividerBorderColor, dividerStyle },
  }) => {
    const { focusTo } = useComponent();

    const height = useMemo(() => {
      return (dividerHeight / 5) * 35;
    }, [dividerHeight]);

    return (
      <div
        id={isBuilder ? `mcomp-${id}` : undefined}
        style={
          {
            "--divider-color": dividerBorderColor,
            paddingTop: `${height}px`,
            marginBottom: `${height}px`,
            borderColor: `var(--divider-color)`,
          } as any
        }
        className={cn(
          "opacity-70 mx-2 w-full",
          dividerStyle === "bordered" && `border-b`
        )}
        onClick={() => {
          if (isBuilder) {
            focusTo(id as string);
          }
        }}
      />
    );
  },
} as IMicrositeComponent<MComponentDivider>;

export default DividerComponent;
